import { OrganizationType } from '../models/Organization';
import type { PassTargetType } from '../models/Pass';

/** Rehearsal (ROOM) pass create is a business-studio product, not individual-tutor. */
export function hostCanCreateRehearsalPasses(
  organizationType: OrganizationType | null | undefined,
): boolean {
  return organizationType !== OrganizationType.INDIVIDUAL_TUTOR;
}

export function defaultHostPassTargetType(
  organizationType: OrganizationType | null | undefined,
): PassTargetType {
  return organizationType === OrganizationType.INDIVIDUAL_TUTOR ? 'LESSON_OPTION' : 'ROOM';
}
